/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  CircularProgress,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Collapse,
  Tooltip,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Divider,
} from '@material-ui/core';
import {
  Close,
  VideoLibrary,
  Public,
  Lock,
  Group,
  CheckCircle,
  ExpandMore,
  ExpandLess,
  PlayArrow,
  Edit,
  Delete,
  Category,
  PlaylistPlay,
  Visibility,
  CloudUpload,
  Add,
  Title as TitleIcon,
  Description as DescriptionIcon,
  Category as CategoryIcon,
  Visibility as VisibilityIcon,
  Refresh as RefreshIcon,
} from '@material-ui/icons';
import useSWR from 'swr';
import { endpoints, dataFetcher, axios, baseUrl } from 'Api';
import { AppContext } from 'Context';
import { v4 as uuid } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import {
  saveUploadInfo,
  saveUploadDetails,
  saveDummy,
  removeDummy,
} from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import ForNoImage from 'Assets/Placeholder.png';
import { ALLOWED_UPLOADS_COUNT } from 'Commons';
import CreateCategoryPage from 'Pages/private/content-layout/CreateCategory';
import { uploadLargeFile } from '../../Utils/uploadWrapper';
import uploadManager from '../../Utils/uploadManagerNew';
import { getBucketName, generateS3Url } from '../../Api/awsConfig';
import styles from './MultipleVideoUploadModal.module.css';

const MultipleVideoUploadModal = ({
  open,
  onClose,
  initialFiles = [],
  uploadLimitError = null,
  userData = null,
}) => {
  const {
    userDetails,
    setUploadContainer,
    setUploadContainer2,
    setIamUploading,
    draftCategoryState,
    setDraftCategoryState,
    base64ToBinary,
    setAppSnackbar,
    autoSignIn,
    setPopUpModalVisible,
    subscriptionDetails,
    freePlanLimitMb,
    IsfreePlan,
    totalOnGoingUploadSize,
    setShowAddPlaylistModal,
    playlistRefreshTrigger,
    newlyCreatedPlaylistId,
    setNewlyCreatedPlaylistId,
    setShowAddSubCategoryModal,
    subCategoryRefreshTrigger,
    newlyCreatedSubCategoryId,
    setNewlyCreatedSubCategoryId
  } = useContext(AppContext);

  const userId = userDetails?.isSubscription?.user_id || localStorage.getItem('id');
  const navigate = useNavigate();

  // Redux for upload tracking
  const dispatch = useDispatch();
  const uploadPercentages = useSelector((state) => state.upload);
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  const updateUploadDetails = (draft_id, data) => {
    dispatch(saveUploadDetails({ [draft_id]: data }));
  };

  // State for all videos
  const [videos, setVideos] = useState([]);
  const [expandedVideos, setExpandedVideos] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [isLoadingVideos, setIsLoadingVideos] = useState(false);
  const [currentLimitError, setCurrentLimitError] = useState(null);
  const [thumbnailProgress, setThumbnailProgress] = useState({});
  const [isGeneratingThumbnails, setIsGeneratingThumbnails] = useState(false);
  const [pendingThumbnailGeneration, setPendingThumbnailGeneration] = useState(new Set());
  const [completedThumbnailGeneration, setCompletedThumbnailGeneration] = useState(new Set());

  // Ref for additional file input
  const additionalFileInputRef = useRef(null);

  // Toolbar dialog states
  const [applyCategoryDialogOpen, setApplyCategoryDialogOpen] = useState(false);
  const [selectedCategoryForAll, setSelectedCategoryForAll] = useState('');
  const [applyVisibilityDialogOpen, setApplyVisibilityDialogOpen] = useState(false);
  const [selectedVisibilityForAll, setSelectedVisibilityForAll] = useState('2');

  // Global data states
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsLoaded, setGroupsLoaded] = useState(false);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [pendingVideoIdForCategory, setPendingVideoIdForCategory] = useState(null);
  const [pendingVideoIdForSubCategory, setPendingVideoIdForSubCategory] = useState(null);
  const [pendingVideoIdForPlaylist, setPendingVideoIdForPlaylist] = useState(null);
  const pendingVideoIdRef = useRef(null);

  // Track if we've applied default categories to prevent repeated updates
  const categoriesAppliedRef = useRef(false);
  // console.log('videos data>>>>>', videos);

  // Function to check and update upload limit error based on current video count
  const checkUploadLimit = useCallback(
    (currentVideoCount, updateErrorState = true, videosToCheck = []) => {
      // Check if user has data and no subscription
      if (userData && userData.subscription == null) {
        // Get currently uploading/pending items from upload manager
        const currentlyUploadingCount = uploadManager.getCurrentlyUploadingCount();

        // Check upload count limit
        const totalAfterCurrent = (userData.totalContentUploaded || 0)
          + currentlyUploadingCount
          + currentVideoCount;
        console.log('totalAfterCurrent', totalAfterCurrent);
        if (totalAfterCurrent > ALLOWED_UPLOADS_COUNT) {
          const errorData = {
            currentCount: userData.totalContentUploaded || 0,
            currentlyUploading: currentlyUploadingCount,
            tryingToUpload: currentVideoCount,
            maxAllowed: ALLOWED_UPLOADS_COUNT,
            message: `You can upload a maximum of ${ALLOWED_UPLOADS_COUNT} files on free plan. ${userData.totalContentUploaded === 0
              ? `You are trying to upload ${currentVideoCount}.`
              : `You can upload ${ALLOWED_UPLOADS_COUNT - (userData.totalContentUploaded + currentlyUploadingCount)
              } more files`
              }`,
          };

          if (updateErrorState) setCurrentLimitError(errorData);
          return errorData;
        }

        // Check file size limit for free plan users
        if (freePlanLimitMb && videosToCheck.length > 0) {
          const totalSizeMB = videosToCheck.reduce((sum, video) => sum + (video.size / 1024 / 1024), 0);
          const usedStorage = subscriptionDetails?.storageUsed?.total_storage;
          const allowedStorage = (usedStorage + totalOnGoingUploadSize) - freePlanLimitMb;
          const formattedStorage = (Math.abs(allowedStorage) / 1024).toFixed(2);
          const allFullStorage = totalSizeMB + usedStorage + totalOnGoingUploadSize;
          const exceededBy = allFullStorage - freePlanLimitMb;
          console.log('totalSizeMB:', allFullStorage, totalSizeMB, usedStorage, freePlanLimitMb, totalOnGoingUploadSize);
          if (IsfreePlan && allFullStorage > freePlanLimitMb) {
            const errorData = {
              totalSize: allFullStorage.toFixed(2),
              maxAllowed: freePlanLimitMb,
              message: `You can upload files up to ${Math.floor(freePlanLimitMb / 1024)} GB on the free plan. You can add ${formattedStorage} GB more.`,
            };
            if (updateErrorState) setCurrentLimitError(errorData);
            return errorData;
          }
        }
      }

      // No error - clear any existing error
      if (updateErrorState) setCurrentLimitError(null);
      return null;
    },
    [userData, uploadPercentages, freePlanLimitMb]
  );

  // Check upload limit during video processing but don't show error yet
  useEffect(() => {
    if (isLoadingVideos && userData) {
      // Silently check upload limit while videos are loading so it's ready when loading completes
      checkUploadLimit(initialFiles.length);
    }
  }, [isLoadingVideos, initialFiles.length, checkUploadLimit, userData]);

  // Fetch categories
  const { isValidating: gettingCategories, mutate: getCategories } = useSWR(
    [endpoints.getMyCategories],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data }) => {
        if (success && data) {
          setCategories(data);
          categoriesAppliedRef.current = false; // Reset flag when new categories are loaded
        }
      },
    }
  );

  // Fetch subcategories
  const { isValidating: gettingSubCategories, mutate: getSubCategories } = useSWR([endpoints.getMySubCategory], {
    fetcher: (url) => dataFetcher(url),
    onSuccess: ({ success, data }) => {
      if (success && data) {
        setSubCategories(data);
      }
    },
  });

  // Fetch playlists
  const { isValidating: gettingPlaylists, mutate: getPlaylists } = useSWR(
    [endpoints.getMyPlaylist],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data }) => {
        if (success && data) {
          setPlaylists(data);
        }
      },
    }
  );

  // Fetch groups
  const { isValidating: gettingGroups, mutate: getGroups } = useSWR(
    [endpoints.getMyGroups],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data, message }) => {
        if (success && data) {
          setGroups(data);
        } else if (!success && message === 'No Groups found') {
          setGroups([]);
        }
        setGroupsLoaded(true);
      },
      onError: (error) => {
        console.error('Groups API error:', error);
        setGroups([]);
        setGroupsLoaded(true);
      },
    }
  );

  // Manual API calls when modal opens
  useEffect(() => {
    const fetchAllData = async () => {
      if (!open) return;

      // Reset loaded states
      setGroupsLoaded(false);
      categoriesAppliedRef.current = false; // Reset category application flag

      try {
        // Fetch categories
        const categoriesResponse = await dataFetcher(endpoints.getMyCategories);
        if (categoriesResponse.success && categoriesResponse.data) {
          // Sort categories to always show "All Videos" at the top
          const sortedCategories = [...categoriesResponse.data].sort((a, b) => {
            const aIsAllVideos = a.title?.toLowerCase() === 'all videos';
            const bIsAllVideos = b.title?.toLowerCase() === 'all videos';
            if (aIsAllVideos && !bIsAllVideos) return -1;
            if (!aIsAllVideos && bIsAllVideos) return 1;
            return 0; // Keep original order for other categories
          });
          setCategories(sortedCategories);
        }

        // Fetch subcategories
        const subCategoriesResponse = await dataFetcher(
          endpoints.getMySubCategory
        );
        if (subCategoriesResponse.success && subCategoriesResponse.data) {
          setSubCategories(subCategoriesResponse.data);
        }

        // Fetch playlists
        const playlistsResponse = await dataFetcher(endpoints.getMyPlaylist);
        if (playlistsResponse.success && playlistsResponse.data) {
          setPlaylists(playlistsResponse.data);
        }

        // Fetch groups
        const groupsResponse = await dataFetcher(endpoints.getMyGroups);
        if (groupsResponse.success && groupsResponse.data) {
          setGroups(groupsResponse.data);
        } else if (
          !groupsResponse.success
          && groupsResponse.message === 'No Groups found'
        ) {
          setGroups([]);
        }
        setGroupsLoaded(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        setGroupsLoaded(true);
      }
    };

    fetchAllData();
  }, [open]);

  // Refresh playlists when a new playlist is created from the global modal
  useEffect(() => {
    if (playlistRefreshTrigger > 0 && open) {
      const refreshPlaylists = async () => {
        try {
          const playlistsResponse = await dataFetcher(endpoints.getMyPlaylist);
          if (playlistsResponse.success && playlistsResponse.data) {
            setPlaylists(playlistsResponse.data);
            // Auto-select the newly created playlist only for the video that triggered the modal
            if (newlyCreatedPlaylistId && pendingVideoIdForPlaylist) {
              // Convert to number to match the type from API
              const newPlaylistId = typeof newlyCreatedPlaylistId === 'string'
                ? parseInt(newlyCreatedPlaylistId, 10)
                : newlyCreatedPlaylistId;
              setVideos((prevVideos) => prevVideos.map((video) => {
                if (video.id === pendingVideoIdForPlaylist) {
                  return {
                    ...video,
                    selectedPlaylist: newPlaylistId,
                  };
                }
                return video;
              }));
              setNewlyCreatedPlaylistId(null);
              setPendingVideoIdForPlaylist(null);
            }
          }
        } catch (error) {
          console.error('Error refreshing playlists:', error);
        }
      };
      refreshPlaylists();
    }
  }, [playlistRefreshTrigger, open]);

  // Refresh subcategories when a new subcategory is created from the global modal
  useEffect(() => {
    if (subCategoryRefreshTrigger > 0 && open) {
      const refreshSubCategories = async () => {
        try {
          const subCategoriesResponse = await dataFetcher(endpoints.getMySubCategory);
          if (subCategoriesResponse.success && subCategoriesResponse.data) {
            setSubCategories(subCategoriesResponse.data);
            // Auto-select the newly created subcategory only for the video that triggered the modal
            if (newlyCreatedSubCategoryId && pendingVideoIdForSubCategory) {
              // Convert to number to match the type from API
              const newSubCategoryId = typeof newlyCreatedSubCategoryId === 'string'
                ? parseInt(newlyCreatedSubCategoryId, 10)
                : newlyCreatedSubCategoryId;
              setVideos((prevVideos) => prevVideos.map((video) => {
                if (video.id === pendingVideoIdForSubCategory) {
                  return {
                    ...video,
                    selectedSubCategory: newSubCategoryId,
                  };
                }
                return video;
              }));
              setNewlyCreatedSubCategoryId(null);
              setPendingVideoIdForSubCategory(null);
            }
          }
        } catch (error) {
          console.error('Error refreshing subcategories:', error);
        }
      };
      refreshSubCategories();
    }
  }, [subCategoryRefreshTrigger, open]);

  // Handle category creation callback - refresh list and select new category for the video
  const handleCategoryCreated = async () => {
    const videoId = pendingVideoIdRef.current;
    try {
      const categoriesResponse = await dataFetcher(endpoints.getMyCategories);
      if (categoriesResponse.success && categoriesResponse.data) {
        const newCategories = categoriesResponse.data;
        // Select the most recently created category (last in the list by id)
        const sortedCategories = [...newCategories].sort((a, b) => parseInt(b.id, 10) - parseInt(a.id, 10));
        const newestCategory = sortedCategories[0];

        // Sort categories to always show "All Videos" at the top for display
        const sortedCategoriesForDisplay = [...newCategories].sort((a, b) => {
          const aIsAllVideos = a.title?.toLowerCase() === 'all videos';
          const bIsAllVideos = b.title?.toLowerCase() === 'all videos';
          if (aIsAllVideos && !bIsAllVideos) return -1;
          if (!aIsAllVideos && bIsAllVideos) return 1;
          return 0; // Keep original order for other categories
        });

        // First update categories list so the new category is valid
        setCategories(sortedCategoriesForDisplay);

        // Then update the video with the new category
        if (newestCategory && videoId) {
          if (videoId === '__all__') {
            // Apply to all videos
            setVideos((prevVideos) => prevVideos.map((video) => ({
              ...video,
              selectedCategory: {
                value: newestCategory.id,
                name: newestCategory.title,
              },
            })));
          } else {
            // Update the specific video's category
            setVideos((prevVideos) => prevVideos.map((video) => {
              if (video.id === videoId) {
                return {
                  ...video,
                  selectedCategory: {
                    value: newestCategory.id,
                    name: newestCategory.title,
                  },
                };
              }
              return video;
            }));
          }
        }
      }
    } catch (error) {
      console.error('Error refreshing categories:', error);
    } finally {
      pendingVideoIdRef.current = null;
      setPendingVideoIdForCategory(null);
      setShowCreateCategoryModal(false);
    }
  };

  // Helper function to generate thumbnails
  const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  // Generate thumbnails at specific time positions
  const generateThumbnailAtTime = (file, timePosition) => new Promise((resolve) => {
    const video = document.createElement('video');
    const videoUrl = URL.createObjectURL(file);
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.playsInline = true;

    video.onerror = () => {
      URL.revokeObjectURL(videoUrl);
      video.remove();
      resolve(null);
    };

    video.onloadeddata = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const maxWidth = 160;
      const aspectRatio = video.videoHeight / video.videoWidth;
      canvas.width = maxWidth;
      canvas.height = maxWidth * aspectRatio;

      video.currentTime = timePosition;

      video.onseeked = () => {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          async (blob) => {
            if (blob) {
              const base64 = await blobToBase64(blob);
              URL.revokeObjectURL(videoUrl);
              video.remove();
              canvas.remove();
              resolve(base64);
            } else {
              URL.revokeObjectURL(videoUrl);
              video.remove();
              canvas.remove();
              resolve(null);
            }
          },
          'image/jpeg',
          0.7
        );
      };
    };
  });

  const generateThumbnailsFromVideo = (file, thumbnailCount = 6) => new Promise((resolve) => {
    const video = document.createElement('video');
    const videoUrl = URL.createObjectURL(file);
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.playsInline = true;

    // Add error handling for thumbnail generation failure
    video.onerror = () => {
      URL.revokeObjectURL(videoUrl);
      video.remove();
      resolve({
        thumbnails: [], // Empty array indicates failure
        width: 0,
        height: 0,
        duration: 0,
        thumbnailFailed: true,
      });
    };

    video.onloadeddata = () => {
      const { duration } = video;
      const interval = duration / (thumbnailCount + 1);
      const tempThumbnails = [];

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Optimize canvas size for smaller memory footprint
      const maxWidth = 160;
      const aspectRatio = video.videoHeight / video.videoWidth;
      canvas.width = maxWidth;
      canvas.height = maxWidth * aspectRatio;

      let currentIndex = 1;

      const captureNextFrame = () => {
        if (currentIndex > thumbnailCount) {
          URL.revokeObjectURL(videoUrl);
          video.remove();
          canvas.remove();
          resolve({
            thumbnails: tempThumbnails,
            width: video.videoWidth,
            height: video.videoHeight,
            duration,
          });
          return;
        }

        const time = interval * currentIndex;
        video.currentTime = time;

        video.onseeked = () => {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            async (blob) => {
              if (blob) {
                const base64 = await blobToBase64(blob);
                tempThumbnails.push(base64);
              }
              currentIndex += 1;
              captureNextFrame();
            },
            'image/jpeg',
            0.7
          ); // Reduced quality for smaller size
        };
      };

      captureNextFrame();
    };
  });

  // Generate remaining thumbnails for a video one by one with progress tracking
  const generateRemainingThumbnails = async (video, videoIndex, totalVideos) => {
    if (video.thumbnails.length >= 6 || video.thumbnailFailed) {
      return video; // Already has all thumbnails or failed
    }

    try {
      const remainingCount = 5; // Need 5 more thumbnails
      const allThumbnails = [...video.thumbnails];

      // Calculate evenly distributed time positions for all 6 thumbnails
      const { duration } = video;
      const totalThumbnails = 6;
      const interval = duration / (totalThumbnails + 1);

      // We already have the first thumbnail at position: interval * 1
      // Now generate thumbnails at positions 2, 3, 4, 5, 6
      const timePositions = [];
      for (let i = 2; i <= totalThumbnails; i += 1) {
        timePositions.push(interval * i);
      }

      // Generate thumbnails one by one using reduce to avoid await in loop
      await Array.from({ length: remainingCount }).reduce(async (promise, _, i) => {
        await promise; // Wait for previous iteration

        setThumbnailProgress((prev) => ({
          ...prev,
          [video.id]: {
            current: i + 1,
            total: remainingCount,
            videoIndex: videoIndex + 1,
            totalVideos,
          },
        }));

        // Generate thumbnail at specific time position
        const thumbnail = await generateThumbnailAtTime(video.file, timePositions[i]);

        if (thumbnail) {
          allThumbnails.push(thumbnail);

          // Update video with new thumbnail immediately
          setVideos((prevVideos) => prevVideos.map((v) => {
            if (v.id === video.id) {
              return {
                ...v,
                thumbnails: [...allThumbnails],
              };
            }
            return v;
          }));
        }
      }, Promise.resolve());

      // Clear progress for this video
      setThumbnailProgress((prev) => {
        const newProgress = { ...prev };
        delete newProgress[video.id];
        return newProgress;
      });

      // Mark as completed
      setCompletedThumbnailGeneration((prev) => {
        const newSet = new Set(prev);
        newSet.add(video.id);
        return newSet;
      });

      // Remove completed status after 2 seconds
      setTimeout(() => {
        setCompletedThumbnailGeneration((prev) => {
          const newSet = new Set(prev);
          newSet.delete(video.id);
          return newSet;
        });
      }, 2000);

      return {
        ...video,
        thumbnails: allThumbnails,
      };
    } catch (error) {
      console.error('Error generating additional thumbnails:', error);
      // Clear progress on error
      setThumbnailProgress((prev) => {
        const newProgress = { ...prev };
        delete newProgress[video.id];
        return newProgress;
      });
    }

    return video; // Return original if generation fails
  };

  // Initialize videos from files
  useEffect(() => {
    const processVideos = async () => {
      if (initialFiles.length > 0 && open) {
        setIsLoadingVideos(true);

        // Generate only 1 thumbnail initially for faster display
        const videoPromises = initialFiles.map(async (file) => {
          const id = uuid();
          const videoData = await generateThumbnailsFromVideo(file, 1); // Only 1 thumbnail
          const filename = file.name.replace(/\.[^/.]+$/, '');

          // Handle failed thumbnail generation
          const thumbnails = videoData.thumbnails && videoData.thumbnails.length > 0
            ? videoData.thumbnails
            : [ForNoImage]; // Use ForNoImage as fallback when generation fails

          return {
            id,
            file,
            title: filename,
            description: '',
            visibility: '2', // Public
            selectedCategory:
              categories.length > 0
                ? { value: categories[0].id, name: categories[0].title }
                : { value: '', name: '' },
            selectedSubCategory: '',
            selectedPlaylist: '',
            selectedGroups: [],
            thumbnails,
            selectedThumbnail: 0,
            isGeneratingThumbnails: false,
            duration: videoData.duration || 0,
            size: file.size,
            width: videoData.width || 0,
            height: videoData.height || 0,
            thumbnailFailed: videoData.thumbnailFailed || false,
          };
        });

        const processedVideos = await Promise.all(videoPromises);
        setVideos(processedVideos);
        setIsLoadingVideos(false);

        // Generate remaining thumbnails in the background after list is shown
        setTimeout(async () => {
          setIsGeneratingThumbnails(true);

          // Mark all videos as pending
          setPendingThumbnailGeneration(new Set(processedVideos.map((v) => v.id)));

          // Generate thumbnails for each video sequentially to show progress using reduce
          await processedVideos.reduce(async (promise, video, i) => {
            await promise;

            // Remove from pending before starting generation
            setPendingThumbnailGeneration((prev) => {
              const newSet = new Set(prev);
              newSet.delete(video.id);
              return newSet;
            });

            await generateRemainingThumbnails(video, i, processedVideos.length);
          }, Promise.resolve());

          setIsGeneratingThumbnails(false);
          setPendingThumbnailGeneration(new Set());
        }, 100); // Small delay to ensure UI updates first
      }
    };

    processVideos();
  }, [initialFiles, open]); // eslint-disable-line

  // Update existing videos when categories are loaded
  useEffect(() => {
    if (
      categories.length > 0
      && videos.length > 0
      && !categoriesAppliedRef.current
    ) {
      const defaultCategory = categories[0]; // First category should be "All Videos"

      const needsUpdate = videos.some((video) => {
        const hasValidCategory = video.selectedCategory.value
          && categories.find((cat) => cat.id === video.selectedCategory.value);
        return !hasValidCategory;
      });

      if (needsUpdate) {
        setVideos((prevVideos) => prevVideos.map((video) => {
          const hasValidCategory = video.selectedCategory.value
            && categories.find((cat) => cat.id === video.selectedCategory.value);

          if (!hasValidCategory) {
            return {
              ...video,
              selectedCategory: {
                value: defaultCategory.id,
                name: defaultCategory.title,
              },
            };
          }
          return video;
        }));
        categoriesAppliedRef.current = true;
      }
    }
  }, [categories, videos]);

  // Initialize and update limit error when video count changes
  useEffect(() => {
    if (videos.length > 0 && !isLoadingVideos && userData) {
      checkUploadLimit(videos.length, true, videos);
    } else if (videos.length === 0) {
      setCurrentLimitError(null);
    }
  }, [videos.length, isLoadingVideos, checkUploadLimit, userData, videos]);

  // Initialize limit error when userData changes
  useEffect(() => {
    if (videos.length > 0 && userData) {
      checkUploadLimit(videos.length, true, videos);
    }
  }, [videos.length, checkUploadLimit, userData, videos]);

  const updateVideo = useCallback(
    (videoId, updates) => {
      setVideos((prevVideos) => prevVideos.map((video) => (video.id === videoId ? { ...video, ...updates } : video)));

      // Auto-expand if visibility is changed to Group but no groups selected
      if (updates.visibility === '3') {
        const video = videos.find((v) => v.id === videoId);
        if (!video?.selectedGroups || video.selectedGroups.length === 0) {
          setExpandedVideos((prev) => ({
            ...prev,
            [videoId]: true,
          }));
        }
      }
    },
    [videos]
  );

  const removeVideo = useCallback((videoId) => {
    setVideos((prevVideos) => {
      const videoToRemove = prevVideos.find((v) => v.id === videoId);
      if (videoToRemove?.thumbnails) {
        videoToRemove.thumbnails.forEach((url) => {
          if (url && url.startsWith('blob:')) {
            URL.revokeObjectURL(url);
          }
        });
      }
      return prevVideos.filter((video) => video.id !== videoId);
    });
  }, []);

  const toggleExpanded = useCallback((videoId) => {
    setExpandedVideos((prev) => ({
      ...prev,
      [videoId]: !prev[videoId],
    }));
  }, []);

  const handleAddMoreVideos = useCallback(
    async (event) => {
      const files = Array.from(event.target.files);
      const allowedVideoTypes = [
        '.mp4',
        '.mov',
        '.mpg',
        '.m4v',
        '.m2ts',
        '.hevc',
        '.h264',
      ];

      const videoFiles = [];
      const invalidFiles = [];

      files.forEach((file) => {
        const fileExtension = file.name
          .toLowerCase()
          .slice(file.name.lastIndexOf('.'));
        if (allowedVideoTypes.includes(fileExtension)) {
          videoFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        setAppSnackbar({
          isVisible: true,
          message: `Unsupported file format(s): ${invalidFiles.join(
            ', '
          )}. Please upload videos in MP4, MOV, MPG, M4V, M2TS, HEVC, or H264 format.`,
          type: 'error',
        });
      }

      if (videoFiles.length === 0) {
        return;
      }

      setIsLoadingVideos(true);

      // Pre-check upload limit silently during video processing (don't update error state yet)
      const currentVideoCount = videos.length;
      const totalVideosAfterAdding = currentVideoCount + videoFiles.length;

      // Silently check limit during processing using cached userData
      if (userData) {
        checkUploadLimit(totalVideosAfterAdding, false);
      }

      // Generate only 1 thumbnail initially for faster display
      const videoPromises = videoFiles.map(async (file) => {
        const id = uuid();
        const videoData = await generateThumbnailsFromVideo(file, 1); // Only 1 thumbnail
        const filename = file.name.replace(/\.[^/.]+$/, '');

        // Handle failed thumbnail generation
        const thumbnails = videoData.thumbnails && videoData.thumbnails.length > 0
          ? videoData.thumbnails
          : [ForNoImage]; // Use ForNoImage as fallback when generation fails

        return {
          id,
          file,
          title: filename,
          description: '',
          visibility: '2', // Public
          selectedCategory:
            categories.length > 0
              ? { value: categories[0].id, name: categories[0].title }
              : { value: '', name: '' },
          selectedSubCategory: '',
          selectedPlaylist: '',
          selectedGroups: [],
          thumbnails,
          selectedThumbnail: 0,
          isGeneratingThumbnails: false,
          duration: videoData.duration || 0,
          size: file.size,
          width: videoData.width || 0,
          height: videoData.height || 0,
          thumbnailFailed: videoData.thumbnailFailed || false,
        };
      });

      const newVideos = await Promise.all(videoPromises);
      setVideos((prevVideos) => [...prevVideos, ...newVideos]);
      setIsLoadingVideos(false);

      // Generate remaining thumbnails in the background after list is shown
      setTimeout(async () => {
        setIsGeneratingThumbnails(true);
        const currentTotalVideos = videos.length + newVideos.length;

        // Mark all new videos as pending
        setPendingThumbnailGeneration((prev) => {
          const newSet = new Set(prev);
          newVideos.forEach((v) => newSet.add(v.id));
          return newSet;
        });

        // Generate thumbnails for each new video sequentially to show progress using reduce
        await newVideos.reduce(async (promise, video, i) => {
          await promise;

          // Remove from pending before starting generation
          setPendingThumbnailGeneration((prev) => {
            const newSet = new Set(prev);
            newSet.delete(video.id);
            return newSet;
          });

          await generateRemainingThumbnails(video, videos.length + i, currentTotalVideos);
        }, Promise.resolve());

        setIsGeneratingThumbnails(false);
        setPendingThumbnailGeneration((prev) => {
          const newSet = new Set(prev);
          newVideos.forEach((v) => newSet.delete(v.id));
          return newSet;
        });
      }, 100); // Small delay to ensure UI updates first

      // Clear the input
      if (additionalFileInputRef.current) {
        additionalFileInputRef.current.value = '';
      }
    },
    [categories, videos.length, userData, checkUploadLimit]
  );

  const getVisibilityIcon = (visibility) => {
    switch (visibility) {
      case '1':
        return <Lock style={{ fontSize: 16, color: '#EF4444' }} />;
      case '3':
        return <Group style={{ fontSize: 16, color: '#8B5CF6' }} />;
      default:
        return <Public style={{ fontSize: 16, color: '#10B981' }} />;
    }
  };

  const getVisibilityText = (visibility) => {
    switch (visibility) {
      case '1':
        return 'Private';
      case '3':
        return 'Group';
      default:
        return 'All Viewers';
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '0 MB';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${Math.round((bytes / 1024 ** i) * 100) / 100} ${sizes[i]}`;
  };

  const handleClose = useCallback(() => {
    // Clean up all blob URLs
    videos.forEach((video) => {
      if (video.thumbnails) {
        video.thumbnails.forEach((url) => {
          if (url && url.startsWith('blob:')) {
            URL.revokeObjectURL(url);
          }
        });
      }
    });
    setVideos([]);
    setExpandedVideos({});
    onClose();
  }, [videos, onClose]);

  // Helper functions
  const changeSize = (size) => {
    const newSize = size / 1024 / 1024;
    return newSize.toFixed(2);
  };

  const addVideoToAPI = async (draftID, draftCategoryState) => {
    try {
      const apiUrl = `${baseUrl}/V6/addVideo`;
      const formData = new FormData();
      const draftData = draftCategoryState[draftID];
      if (draftData) {
        formData.append('draft_id', draftID || '');
        formData.append('title', draftData.title || '');
        formData.append('category_id', draftData.category || '');
        formData.append('file_name', draftData.fileName || '');
        if (draftData.thumbnail) {
          try {
            const binaryThumbnail = base64ToBinary(draftData.thumbnail);
            formData.append('thumbnail', binaryThumbnail);
          } catch (error) {
            console.error('Main thumbnail conversion failed:', error.message);
          }
        }
        if (draftData.thumbnails && Array.isArray(draftData.thumbnails)) {
          draftData.thumbnails.forEach((binaryThumbnail, index) => {
            if (binaryThumbnail) {
              formData.append('thumbnails[]', binaryThumbnail);
            }
          });
        }
        formData.append('description', draftData.description || '');
        formData.append('video_size', changeSize(draftData.videoSize) || '');
        formData.append(
          'group_ids', (draftData.selectedGroups || []).join(',')
        );
        formData.append('visibility', draftData.visibility || '');
        formData.append(
          'subcategory_id',
          draftData.selectedSubCategory || ''
        );
        formData.append('playlist_ids', draftData.selectedPlaylist || '');
        formData.append('videoHeight', draftData.videoHeight || '');
        formData.append('videoWidth', draftData.videoWidth || '');
        formData.append('videoOreintation', draftData.orientation || '');
        formData.append('s3_status', draftData.uploadStatus || '');
        formData.append('uploadKey', draftData.uploadKey || '');
        formData.append(
          'bucket_folder_path',
          `${draftData.s3Url}${draftData.uploadBucket}/${draftData.uploadKey}`
        );
        formData.append('s3_image_bucket_url', draftData.s3Url || '');
      }
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error adding video to API:', error.message || error);
      throw error;
    }
  };

  const updateDummy = (dummy, status = 0) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };

  const uploadSingleVideo = async (video) => {
    const fileExtension = video.file.name.split('.').pop().toLowerCase();
    const number = Math.floor(Math.random() * 10000) + 1;
    const fileName = `${Date.now()}-${userId}-video-${number}.${fileExtension}`;
    const bucketName = getBucketName(userId);
    const s3Url = generateS3Url();
    const draftID = uuid();

    // Get main thumbnail (handle both normal thumbnails and ForNoImage case)
    let thumbnailBase64 = '';
    const selectedThumbnail = video.thumbnails[video.selectedThumbnail];

    if (
      selectedThumbnail === ForNoImage
      || video.selectedThumbnail === video.thumbnails.length
    ) {
      // User selected ForNoImage option (either ForNoImage path or index beyond array)
      // Convert ForNoImage to base64
      const response = await fetch(ForNoImage);
      const blob = await response.blob();
      thumbnailBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } else if (selectedThumbnail && selectedThumbnail.startsWith('data:')) {
      // Normal base64 thumbnail selected
      thumbnailBase64 = selectedThumbnail;
    }

    // Convert all thumbnails to binary in parallel (thumbnails are already base64)
    const thumbnailsBinary = await Promise.all(
      video.thumbnails.map(async (thumbnail, i) => {
        try {
          // Handle ForNoImage case (when thumbnail generation failed)
          if (thumbnail === ForNoImage) {
            // Convert ForNoImage to base64 then to binary
            const response = await fetch(ForNoImage);
            const blob = await response.blob();
            const base64 = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            });
            return base64ToBinary(base64);
          }

          if (!thumbnail) {
            return null;
          }
          const binary = base64ToBinary(thumbnail);
          return binary;
        } catch (error) {
          console.error(`Error converting thumbnail ${i}:`, error.message);
          return null;
        }
      })
    );

    return new Promise((resolve, reject) => {
      uploadLargeFile({
        bucket: bucketName,
        key: fileName,
        file: video.file,
        draftId: draftID,
        uploadPercentages,
        updateUploadPercentages,
        setUploadContainer,
        setUploadContainer2,
        setIamUploading,
        dummyData: {
          title: video.title,
          fileName,
          thumbnail: thumbnailBase64,
          thumbnails: thumbnailsBinary,
          category: video.selectedCategory.name,
          description: video.description,
          videoSize: video.size,
          selectedGroups: video.selectedGroups,
          changeSize,
        },
        updateDummy,
        setDraftCategoryState,
        onSuccess: async (draft_id) => {
          const updatedDraftData = {
            title: video.title,
            category: video.selectedCategory.value,
            fileName: video.file?.name,
            thumbnail: thumbnailBase64,
            thumbnails: thumbnailsBinary,
            description: video.description,
            videoSize: video.size,
            selectedGroups: video.selectedGroups,
            visibility: video.visibility,
            selectedSubCategory: video.selectedSubCategory,
            selectedPlaylist: video.selectedPlaylist,
            videoHeight: video.height,
            videoWidth: video.width,
            orientation: video.height < video.width ? 1 : 2,
            uploadStatus: 'completed',
            uploadKey: fileName,
            uploadBucket: bucketName,
            s3Url,
          };

          setDraftCategoryState((prevState) => ({
            ...prevState,
            [draft_id]: updatedDraftData,
          }));

          const tempDraftState = {
            [draft_id]: updatedDraftData,
          };

          try {
            await addVideoToAPI(draft_id, tempDraftState);
            resolve();
          } catch (error) {
            console.error('Failed to add video to API:', error);
            reject(error);
          }
        },
        onError: (error, draft_id) => {
          console.error('Upload failed for draft:', draft_id, error);
          reject(error);
        },
        updateUploadDetails,
      });
    });
  };

  // Toolbar handlers
  const handleClearAllTitles = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => ({
      ...video,
      title: '',
    })));
  }, []);

  const handleClearAllDescriptions = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => ({
      ...video,
      description: '',
    })));
  }, []);

  const handleApplyCategoryToAll = useCallback(() => {
    if (selectedCategoryForAll) {
      const selectedCat = categories.find(
        (cat) => cat.id === selectedCategoryForAll
      );
      if (selectedCat) {
        setVideos((prevVideos) => prevVideos.map((video) => ({
          ...video,
          selectedCategory: {
            value: selectedCat.id,
            name: selectedCat.title,
          },
        })));
        setApplyCategoryDialogOpen(false);
        setSelectedCategoryForAll('');
      }
    }
  }, [selectedCategoryForAll, categories]);

  const handleApplyVisibilityToAll = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => ({
      ...video,
      visibility: selectedVisibilityForAll,
      // Clear groups if not group visibility
      selectedGroups:
        selectedVisibilityForAll === '3' ? video.selectedGroups : [],
    })));
    // If setting to group visibility, expand all videos to show group selection
    if (selectedVisibilityForAll === '3') {
      const expandedState = {};
      videos.forEach((video) => {
        expandedState[video.id] = true;
      });
      setExpandedVideos(expandedState);
    }
    setApplyVisibilityDialogOpen(false);
  }, [selectedVisibilityForAll, videos]);

  const handleResetAll = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => {
      const filename = video.file.name.replace(/\.[^/.]+$/, '');
      return {
        ...video,
        title: filename,
        description: '',
        visibility: '2',
        selectedCategory:
          categories.length > 0
            ? { value: categories[0].id, name: categories[0].title }
            : { value: '', name: '' },
        selectedSubCategory: '',
        selectedPlaylist: '',
        selectedGroups: [],
      };
    }));
    setExpandedVideos({});
  }, [categories]);

  const handlePublishAll = async () => {
    if (videos.length === 0) return;

    // Validate group selection for videos with Group visibility
    const invalidVideos = videos.filter(
      (video) => video.visibility === '3'
        && (!video.selectedGroups || video.selectedGroups.length === 0)
    );

    if (invalidVideos.length > 0) {
      // Auto-expand videos that need group selection
      const expandedState = {};
      invalidVideos.forEach((video) => {
        expandedState[video.id] = true;
      });
      setExpandedVideos((prev) => ({
        ...prev,
        ...expandedState,
      }));

      alert(
        `Please select at least one group for the following videos with Group visibility:\n${invalidVideos
          .map((v) => `• ${v.title || 'Untitled Video'}`)
          .join('\n')}`
      );
      return;
    }

    setIsUploading(true);

    // Close modal immediately after starting uploads
    handleClose();
    navigate(Pathname.yourVideos);

    try {
      // Upload all videos in parallel (or sequentially based on preference)
      const uploadPromises = videos.map((video) => uploadSingleVideo(video));
      await Promise.all(uploadPromises);

      console.log('All videos uploaded successfully');
    } catch (error) {
      console.error('Error uploading videos:', error);
    } finally {
      setIsUploading(false);
    }
  };
  const sameToAllowed = userData?.totalContentUploaded + videos.length === ALLOWED_UPLOADS_COUNT;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          maxWidth: 1200,
          maxHeight: '90vh',
        },
      }}
    >
      <DialogContent
        style={{ padding: 0, display: 'flex', flexDirection: 'column' }}
      >
        {/* Header */}
        <div className={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CloudUpload
              style={{ color: '#5aa5ef', fontSize: 24, marginRight: 12 }}
            />
            <Typography variant="h6" className={styles.title}>
              <>
                Videos will be published to
                {' '}
                <strong>{categories[0]?.title || 'All Videos'}</strong>
                {' '}
                unless
                category is selected
              </>
            </Typography>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {isGeneratingThumbnails && (
              <Chip
                icon={<CircularProgress size={14} style={{ color: '#5aa5ef' }} />}
                label="Generating thumbnails..."
                size="small"
                style={{
                  backgroundColor: '#EFF6FF',
                  color: '#5aa5ef',
                  fontFamily: 'Montserrat',
                  fontSize: 12,
                  fontWeight: 500,
                }}
              />
            )}
            {videos.length > 0 && (
              <>
                <input
                  ref={additionalFileInputRef}
                  type="file"
                  accept=".mp4,.mov,.mpg,.m4v,.m2ts,.hevc,.h264"
                  multiple
                  onChange={handleAddMoreVideos}
                  style={{ display: 'none' }}
                />
                <Button
                  onClick={() => additionalFileInputRef.current?.click()}
                  variant="outlined"
                  size="small"
                  startIcon={<Add />}
                  disabled={currentLimitError || sameToAllowed}
                  style={{
                    color:
                      currentLimitError || sameToAllowed
                        ? '#9CA3AF'
                        : '#5aa5ef',
                    borderColor:
                      currentLimitError || sameToAllowed
                        ? '#D1D5DB'
                        : '#5aa5ef',
                    textTransform: 'none',
                    fontFamily: 'Montserrat',
                  }}
                >
                  Add More Videos
                </Button>
              </>
            )}
            {/* <IconButton onClick={handleClose} style={{ color: '#6B7280' }}>
              <Close />
            </IconButton> */}
          </div>
        </div>

        {currentLimitError && !isLoadingVideos && (
          <div
            style={{
              margin: '8px 24px 16px 24px',
              padding: 16,
              backgroundColor: '#FEF2F2',
              border: '1px solid #FECACA',
              borderRadius: 8,
              color: '#DC2626',
            }}
          >
            <h4 style={{ margin: '0 0 8px 0', fontSize: 14, fontWeight: 600 }}>
              Upload Limit Exceeded
            </h4>
            <p style={{ margin: '0 0 8px 0', fontSize: 12, lineHeight: 1.4 }}>
              {currentLimitError.message}
            </p>
            <a
              href={Pathname.plans}
              style={{
                color: '#5aa5ef',
                fontSize: 12,
                textDecoration: 'underline',
                fontWeight: 500,
              }}
              onClick={(e) => {
                e.preventDefault();
                navigate(Pathname.plans);
                handleClose();
              }}
            >
              Upgrade plan
            </a>
          </div>
        )}

        {/* Content */}
        <div className={styles.content}>
          {isLoadingVideos ? (
            <div className={styles.emptyState}>
              <CircularProgress
                size={48}
                style={{ color: '#5aa5ef', marginBottom: 16 }}
              />
              <Typography variant="h6" className={styles.processingText}>
                Processing videos...
              </Typography>
              <Typography variant="body2" className={styles.processingSubText}>
                Generating thumbnails and preparing upload details
              </Typography>
            </div>
          ) : videos.length === 0 ? (
            <div className={styles.emptyState}>
              <VideoLibrary
                style={{ fontSize: 64, color: '#D1D5DB', marginBottom: 16 }}
              />
              <Typography variant="h6" className={styles.noVideosText}>
                No videos selected
              </Typography>
              <Typography variant="body2" className={styles.noVideosSubText}>
                Please select multiple video files to upload
              </Typography>
            </div>
          ) : (
            <TableContainer component={Paper} className={styles.tableContainer}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 120 }}
                    >
                      Thumbnail
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 250 }}
                    >
                      Title
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 180 }}
                    >
                      Category
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 120 }}
                    >
                      Visibility
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 100 }}
                    >
                      Size
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 120 }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {videos.map((video) => (
                    <React.Fragment key={video.id}>
                      {/* Main Row */}
                      <TableRow
                        className={`${styles.videoRow} ${video.visibility === '3'
                          && (!video.selectedGroups
                            || video.selectedGroups.length === 0)
                          ? styles.videoRowWarning
                          : ''
                          }`}
                      >
                        {/* Thumbnail */}
                        <TableCell>
                          <div className={styles.thumbnailContainer} style={{ position: 'relative' }}>
                            {video.thumbnails && video.thumbnails.length > 0 ? (
                              <>
                                <img
                                  src={
                                    video.selectedThumbnail
                                      === video.thumbnails.length
                                      ? ForNoImage
                                      : video.thumbnails[video.selectedThumbnail]
                                  }
                                  alt="Thumbnail"
                                  className={styles.thumbnail}
                                />
                                {(thumbnailProgress[video.id] || pendingThumbnailGeneration.has(video.id)) && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: 8,
                                    }}
                                  >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                      <CircularProgress size={20} style={{ color: '#5aa5ef' }} />
                                      <Typography
                                        variant="caption"
                                        style={{
                                          color: 'white',
                                          fontSize: 10,
                                          marginTop: 2,
                                          fontFamily: 'Montserrat',
                                        }}
                                      >
                                        {thumbnailProgress[video.id]
                                          ? `${thumbnailProgress[video.id].current}/${thumbnailProgress[video.id].total}`
                                          : 'Pending'}
                                      </Typography>
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className={styles.thumbnailPlaceholder}>
                                <CircularProgress size={24} />
                              </div>
                            )}
                          </div>
                        </TableCell>

                        {/* Title */}
                        <TableCell>
                          <TextField
                            value={video.title}
                            onChange={(e) => updateVideo(video.id, { title: e.target.value })}
                            variant="outlined"
                            size="small"
                            fullWidth
                            className={styles.titleField}
                          />
                        </TableCell>

                        {/* Category */}
                        <TableCell>
                          {gettingCategories ? (
                            <div className={styles.loadingContainer}>
                              <CircularProgress
                                size={20}
                                style={{ color: '#5aa5ef' }}
                              />
                            </div>
                          ) : (
                            <FormControl
                              fullWidth
                              size="small"
                              variant="outlined"
                            >
                              <Select
                                value={video.selectedCategory.value}
                                onChange={(e) => {
                                  if (e.target.value === '__create_new__') {
                                    pendingVideoIdRef.current = video.id;
                                    setPendingVideoIdForCategory(video.id);
                                    setShowCreateCategoryModal(true);
                                    return;
                                  }
                                  const selectedCat = categories.find(
                                    (cat) => cat.id === e.target.value
                                  );
                                  updateVideo(video.id, {
                                    selectedCategory: {
                                      value: e.target.value,
                                      name: selectedCat?.title || '',
                                    },
                                  });
                                }}
                                className={styles.selectField}
                                disabled={categories.length === 0}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 300,
                                    },
                                  },
                                  anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                  },
                                  transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                  },
                                  getContentAnchorEl: null,
                                  autoFocus: false,
                                  disableAutoFocusItem: true,
                                }}
                              >
                                <MenuItem value="__create_new__">
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      color: '#5aa5ef',
                                    }}
                                  >
                                    <Add
                                      style={{
                                        fontSize: 16,
                                        marginRight: 8,
                                        color: '#5aa5ef',
                                      }}
                                    />
                                    <span style={{ fontWeight: 600 }}>Create New Category</span>
                                  </div>
                                </MenuItem>
                                <Divider style={{ margin: '4px 0' }} />
                                {categories.length === 0 ? (
                                  <MenuItem value="">
                                    <em style={{ color: '#9CA3AF' }}>
                                      Loading categories...
                                    </em>
                                  </MenuItem>
                                ) : (
                                  categories.map((cat) => (
                                    <MenuItem key={cat.id} value={cat.id}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Category
                                          style={{
                                            fontSize: 16,
                                            marginRight: 8,
                                            color: '#6B7280',
                                          }}
                                        />
                                        {cat.title}
                                      </div>
                                    </MenuItem>
                                  ))
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>

                        {/* Visibility */}
                        <TableCell>
                          <Chip
                            icon={getVisibilityIcon(video.visibility)}
                            label={getVisibilityText(video.visibility)}
                            onClick={() => {
                              // Cycle through visibility options
                              const visibilities = ['2', '1', '3']; // Public, Private, Group
                              const currentIndex = visibilities.indexOf(
                                video.visibility
                              );
                              const nextIndex = (currentIndex + 1) % visibilities.length;
                              updateVideo(video.id, {
                                visibility: visibilities[nextIndex],
                              });
                            }}
                            className={styles.visibilityChip}
                            clickable
                          />
                        </TableCell>

                        {/* Size */}
                        <TableCell>
                          <Typography
                            variant="body2"
                            className={styles.sizeText}
                          >
                            {formatFileSize(video.size)}
                          </Typography>
                        </TableCell>

                        {/* Actions */}
                        <TableCell>
                          <div className={styles.actions}>
                            <Tooltip title="More options">
                              <IconButton
                                size="small"
                                onClick={() => toggleExpanded(video.id)}
                                className={`${styles.expandButton} ${expandedVideos[video.id]
                                  ? styles.expanded
                                  : ''
                                  }`}
                              >
                                {expandedVideos[video.id] ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Remove video">
                              <IconButton
                                size="small"
                                onClick={() => removeVideo(video.id)}
                                className={styles.deleteButton}
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>

                      {/* Expanded Row */}
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={6}
                        >
                          <Collapse
                            in={expandedVideos[video.id]}
                            timeout={300}
                            unmountOnExit
                          >
                            <div className={styles.expandedContent}>
                              {/* Thumbnail Selection */}
                              {video.thumbnails
                                && video.thumbnails.length > 0 && (
                                  <div className={styles.thumbnailSelection}>
                                    <Typography
                                      variant="subtitle2"
                                      className={styles.sectionTitle}
                                    >
                                      Select Thumbnail
                                    </Typography>
                                    <div className={styles.thumbnailGrid}>
                                      {video.thumbnails.map((thumb, index) => (
                                        <div
                                          key={index}
                                          onClick={() => updateVideo(video.id, {
                                            selectedThumbnail: index,
                                          })}
                                          className={`${styles.thumbnailGridItem
                                            } ${video.selectedThumbnail === index
                                              ? styles.selected
                                              : ''
                                            }`}
                                        >
                                          <img
                                            src={thumb}
                                            alt={`Thumbnail ${index + 1}`}
                                          />
                                          {video.selectedThumbnail
                                            === index && (
                                              <div
                                                className={
                                                  styles.selectedIndicator
                                                }
                                              >
                                                <CheckCircle
                                                  style={{
                                                    fontSize: 16,
                                                    color: 'white',
                                                  }}
                                                />
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                      {/* Placeholder thumbnail option */}
                                      <div
                                        key="placeholder"
                                        onClick={() => updateVideo(video.id, {
                                          selectedThumbnail:
                                            video.thumbnails.length,
                                        })}
                                        className={`${styles.thumbnailGridItem
                                          } ${video.selectedThumbnail
                                            === video.thumbnails.length
                                            ? styles.selected
                                            : ''
                                          }`}
                                      >
                                        <img
                                          src={ForNoImage}
                                          alt="Placeholder thumbnail"
                                        />
                                        {video.selectedThumbnail
                                          === video.thumbnails.length && (
                                            <div
                                              className={styles.selectedIndicator}
                                            >
                                              <CheckCircle
                                                style={{
                                                  fontSize: 16,
                                                  color: 'white',
                                                }}
                                              />
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                )}

                              {/* Additional Fields */}
                              <div className={styles.additionalFieldsContainer}>
                                <div className={styles.additionalFields}>
                                  {/* Description, Subcategory and Playlist in one compact row */}
                                  <div className={styles.compactFieldRow}>
                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Description
                                      </Typography>
                                      <TextField
                                        value={video.description}
                                        onChange={(e) => updateVideo(video.id, {
                                          description: e.target.value,
                                        })}
                                        placeholder="Add description..."
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        className={styles.descriptionField}
                                      />
                                    </div>

                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Subcategory
                                      </Typography>
                                      {gettingSubCategories ? (
                                        <div
                                          className={styles.loadingContainer}
                                        >
                                          <CircularProgress
                                            size={16}
                                            style={{ color: '#5aa5ef' }}
                                          />
                                        </div>
                                      ) : (
                                        <FormControl
                                          fullWidth
                                          size="small"
                                          variant="outlined"
                                        >
                                          <Select
                                            value={video.selectedSubCategory}
                                            onChange={(e) => {
                                              if (e.target.value === '__create_new__') {
                                                setPendingVideoIdForSubCategory(video.id);
                                                setShowAddSubCategoryModal(true);
                                                return;
                                              }
                                              updateVideo(video.id, {
                                                selectedSubCategory: e.target.value,
                                              });
                                            }}
                                            className={styles.selectField}
                                            MenuProps={{
                                              PaperProps: {
                                                style: {
                                                  maxHeight: 300,
                                                },
                                              },
                                              anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                              },
                                              transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                              },
                                              getContentAnchorEl: null,
                                              autoFocus: false,
                                              disableAutoFocusItem: true,
                                            }}
                                          >
                                            <MenuItem
                                              value="__create_new__"
                                              style={{
                                                position: 'sticky',
                                                top: 0,
                                                backgroundColor: 'white',
                                                zIndex: 1,
                                              }}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center', color: '#5aa5ef' }}>
                                                <Add style={{ fontSize: 16, marginRight: 8, color: '#5aa5ef' }} />
                                                <span style={{ fontSize: 13, fontFamily: 'Montserrat', fontWeight: 600 }}>Add New Subcategory</span>
                                              </div>
                                            </MenuItem>
                                            <Divider style={{ margin: '4px 0', position: 'sticky', top: 36, backgroundColor: 'white', zIndex: 1 }} />
                                            <MenuItem value="">None</MenuItem>
                                            {subCategories.map((subcat) => (
                                              <MenuItem
                                                key={subcat.id}
                                                value={subcat.id}
                                              >
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                  <Category style={{ fontSize: 15, marginRight: 8, color: '#5aa5ef' }} />
                                                  <span style={{ fontFamily: 'Montserrat', fontSize: 13 }}>{subcat.title}</span>
                                                </div>
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      )}
                                    </div>

                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Playlist
                                      </Typography>
                                      {gettingPlaylists ? (
                                        <div
                                          className={styles.loadingContainer}
                                        >
                                          <CircularProgress
                                            size={16}
                                            style={{ color: '#5aa5ef' }}
                                          />
                                        </div>
                                      ) : (
                                        <FormControl
                                          fullWidth
                                          size="small"
                                          variant="outlined"
                                        >
                                          <Select
                                            value={video.selectedPlaylist}
                                            onChange={(e) => {
                                              if (e.target.value === '__create_new__') {
                                                setPendingVideoIdForPlaylist(video.id);
                                                setShowAddPlaylistModal(true);
                                                return;
                                              }
                                              updateVideo(video.id, {
                                                selectedPlaylist:
                                                  e.target.value,
                                              });
                                            }}
                                            className={styles.selectField}
                                            MenuProps={{
                                              PaperProps: {
                                                style: {
                                                  maxHeight: 300,
                                                },
                                              },
                                              anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                              },
                                              transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                              },
                                              getContentAnchorEl: null,
                                              autoFocus: false,
                                              disableAutoFocusItem: true,
                                            }}
                                          >
                                            <MenuItem
                                              value="__create_new__"
                                              style={{
                                                position: 'sticky',
                                                top: 0,
                                                backgroundColor: 'white',
                                                zIndex: 1,
                                              }}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center', color: '#5aa5ef' }}>
                                                <Add style={{ fontSize: 16, marginRight: 8, color: '#5aa5ef' }} />
                                                <span style={{ fontWeight: 600 }}>Add New Playlist</span>
                                              </div>
                                            </MenuItem>
                                            <Divider style={{ margin: '4px 0', position: 'sticky', top: 36, backgroundColor: 'white', zIndex: 1 }} />
                                            <MenuItem value="">None</MenuItem>
                                            {playlists.map((playlist) => (
                                              <MenuItem
                                                key={playlist.id}
                                                value={playlist.id}
                                              >
                                                <PlaylistPlay
                                                  style={{
                                                    fontSize: 16,
                                                    marginRight: 8,
                                                    color: '#5aa5ef',
                                                  }}
                                                />
                                                {playlist.title}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      )}
                                    </div>
                                  </div>

                                  {/* Groups (when visibility is Group) */}
                                  {video.visibility === '3' && (
                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Select Groups
                                      </Typography>
                                      {!groupsLoaded ? (
                                        <div
                                          className={
                                            styles.loadingContainerWithText
                                          }
                                        >
                                          <CircularProgress
                                            size={16}
                                            style={{ color: '#5aa5ef' }}
                                          />
                                          <Typography
                                            variant="body2"
                                            className={styles.loadingText}
                                          >
                                            Loading groups...
                                          </Typography>
                                        </div>
                                      ) : groups.length === 0 ? (
                                        <div
                                          className={`${styles.emptyGroupsContainer
                                            } ${video.visibility === '3'
                                              ? styles.emptyGroupsContainerWarning
                                              : ''
                                            }`}
                                        >
                                          <Typography
                                            variant="body2"
                                            className={styles.emptyGroupsText}
                                          >
                                            No groups available
                                          </Typography>
                                        </div>
                                      ) : (
                                        <div
                                          className={`${styles.groupSelection
                                            } ${!video.selectedGroups
                                              || video.selectedGroups.length === 0
                                              ? styles.groupSelectionWarning
                                              : ''
                                            }`}
                                        >
                                          {groups.map((group) => (
                                            <FormControlLabel
                                              key={group.id}
                                              control={(
                                                <Checkbox
                                                  checked={video.selectedGroups.includes(
                                                    group.id
                                                  )}
                                                  onChange={(e) => {
                                                    const newGroups = e.target
                                                      .checked
                                                      ? [
                                                        ...video.selectedGroups,
                                                        group.id,
                                                      ]
                                                      : video.selectedGroups.filter(
                                                        (id) => id !== group.id
                                                      );
                                                    updateVideo(video.id, {
                                                      selectedGroups: newGroups,
                                                    });
                                                  }}
                                                  size="small"
                                                  style={{ color: '#8B5CF6' }}
                                                />
                                              )}
                                              label={(
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <Group
                                                    style={{
                                                      fontSize: 16,
                                                      marginRight: 8,
                                                      color: '#8B5CF6',
                                                    }}
                                                  />
                                                  {group.title}
                                                </div>
                                              )}
                                              className={styles.groupCheckbox}
                                            />
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>

        {/* Footer Actions */}
        {videos.length > 0 && (
          <div className={styles.footer}>
            <div className={styles.footerInfo}>
              <Typography variant="body2" className={styles.footerText}>
                {videos.length}
                {' '}
                video
                {videos.length !== 1 ? 's' : ''}
                {' '}
                ready to upload
              </Typography>
            </div>
            {/* Toolbar Section */}
            <div className={styles.toolbarSection}>
              <Tooltip title="Clear all titles">
                <IconButton
                  size="small"
                  onClick={handleClearAllTitles}
                  className={styles.toolButton}
                >
                  <TitleIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear all descriptions">
                <IconButton
                  size="small"
                  onClick={handleClearAllDescriptions}
                  className={styles.toolButton}
                >
                  <DescriptionIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Apply same category to all videos">
                <IconButton
                  size="small"
                  onClick={() => setApplyCategoryDialogOpen(true)}
                  className={styles.toolButton}
                >
                  <CategoryIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Apply same visibility to all videos">
                <IconButton
                  size="small"
                  onClick={() => setApplyVisibilityDialogOpen(true)}
                  className={styles.toolButton}
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reset all to original values">
                <IconButton
                  size="small"
                  onClick={handleResetAll}
                  className={styles.toolButton}
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div className={styles.footerActions}>
              <Button onClick={handleClose} className={styles.cancelButton}>
                Cancel
              </Button>
              <Button
                onClick={handlePublishAll}
                disabled={
                  isUploading
                  || gettingCategories
                  || currentLimitError
                  || videos.some((v) => !v.title.trim())
                  || videos.some(
                    (v) => v.visibility === '3'
                      && (!v.selectedGroups || v.selectedGroups.length === 0)
                  )
                }
                variant="contained"
                className={styles.publishButton}
              >
                {isUploading ? (
                  <div className={styles.uploadingContainer}>
                    <CircularProgress
                      size={16}
                      className={styles.uploadingText}
                    />
                    Uploading...
                  </div>
                ) : gettingCategories ? (
                  <div className={styles.uploadingContainer}>
                    <CircularProgress
                      size={16}
                      className={styles.uploadingText}
                    />
                    Loading Categories...
                  </div>
                ) : (
                  <div className={styles.uploadButtonContainer}>
                    <PlayArrow style={{ fontSize: 18 }} />
                    Publish
                  </div>
                )}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>

      {/* Apply Category Dialog */}
      <Dialog
        open={applyCategoryDialogOpen}
        onClose={() => setApplyCategoryDialogOpen(false)}
      >
        <DialogTitle>Apply Category to All Videos</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: 16 }}>
            <Select
              value={selectedCategoryForAll}
              onChange={(e) => {
                if (e.target.value === '__create_new__') {
                  pendingVideoIdRef.current = '__all__';
                  setPendingVideoIdForCategory('__all__');
                  setShowCreateCategoryModal(true);
                  setApplyCategoryDialogOpen(false);
                  return;
                }
                setSelectedCategoryForAll(e.target.value);
              }}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                autoFocus: false,
                disableAutoFocusItem: true,
              }}
            >
              <MenuItem value="__create_new__">
                <div style={{ display: 'flex', alignItems: 'center', color: '#5aa5ef' }}>
                  <Add
                    style={{ fontSize: 16, marginRight: 8, color: '#5aa5ef' }}
                  />
                  <span style={{ fontWeight: 600 }}>Create New Category</span>
                </div>
              </MenuItem>
              <Divider style={{ margin: '4px 0' }} />
              <MenuItem value="" disabled>
                <em>Select a category</em>
              </MenuItem>
              {categories.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Category
                      style={{ fontSize: 16, marginRight: 8, color: '#6B7280' }}
                    />
                    {cat.title}
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setApplyCategoryDialogOpen(false);
              setSelectedCategoryForAll('');
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApplyCategoryToAll}
            variant="contained"
            disabled={!selectedCategoryForAll}
            style={{ backgroundColor: '#5aa5ef' }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      {/* Apply Visibility Dialog */}
      <Dialog
        open={applyVisibilityDialogOpen}
        onClose={() => setApplyVisibilityDialogOpen(false)}
      >
        <DialogTitle>Apply Visibility to All Videos</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: 16 }}>
            <Select
              value={selectedVisibilityForAll}
              onChange={(e) => setSelectedVisibilityForAll(e.target.value)}
            >
              <MenuItem value="2">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Public
                    style={{ fontSize: 16, marginRight: 8, color: '#10B981' }}
                  />
                  All Viewers
                </div>
              </MenuItem>
              <MenuItem value="1">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Lock
                    style={{ fontSize: 16, marginRight: 8, color: '#EF4444' }}
                  />
                  Private
                </div>
              </MenuItem>
              <MenuItem value="3">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Group
                    style={{ fontSize: 16, marginRight: 8, color: '#8B5CF6' }}
                  />
                  Group
                </div>
              </MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApplyVisibilityDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleApplyVisibilityToAll}
            variant="contained"
            style={{ backgroundColor: '#5aa5ef' }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create Category Modal */}
      {showCreateCategoryModal && (
        <CreateCategoryPage
          initialOpen={showCreateCategoryModal}
          onModalClose={() => {
            // Don't reset pendingVideoIdRef here - handleCategoryCreated will handle it
            // onModalClose is called BEFORE onCategoryCreated due to useEffect in CreateCategory
            // So we must preserve the ref value for handleCategoryCreated to use
            setShowCreateCategoryModal(false);
          }}
          onCategoryCreated={handleCategoryCreated}
        />
      )}
    </Dialog>
  );
};

export default MultipleVideoUploadModal;
